import { memo, useRef } from "react";
import { Modal } from "@mui/material";
import { ReactSVG } from "react-svg";
import { VitaPercent } from "Components/Buttons/VitaPercent";

export const CustomMedicaments = memo(function MedicamentsComponent({
  open,
  close,
  data,
}: {
  open: boolean;
  close: () => void;
  data?: any;
}) {
  const containerRef = useRef(null);
  return (
    <>
      <div ref={containerRef}></div>
      <Modal
        open={open}
        onClose={close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        container={containerRef.current}
        className="flex items-center justify-center"
      >
        <div className="w-[644px] sm:w-[100dvh] sm:max-w-full sm:max-h-full sm:rounded-[0px] sm:h-[100dvh] overflow-hidden flex flex-col p-[24px] sm:p-[12px] relative max-w-[90%] max-h-[90%] h-[604px] bg-[#fff] rounded-[12px] outline-none">
          <div className="mb-[24px] flex justify-between items-center">
            <h2 className="font-bold text-[20px] text-blackPrimary-100">
              {data?.data[0]?.headerText}
            </h2>
            <div
              onClick={close}
              className="cursor-pointer w-[44px] h-[44px] bg-gray-30 sm:bg-gray-100 sm:rounded-[8px] rounded-[50%] flex items-center justify-center"
            >
              <ReactSVG src="/images/icons/close.svg" />
            </div>
          </div>
          <div className="customScrolllbar overflow-y-auto h-[100vh-40px]">
            {data?.data?.map((item: any, index: number) => (
              <div
                className="flex items-center gap-4 py-[16px] border-b-[1px] border-solid border-b-gray-30"
                key={index}
              >
                <div className="rounded-[12px] w-[64px] min-w-[64px] h-[64px] bg-gray-100 flex items-center justify-center">
                  <img className="contain" src={item?.image} />
                </div>
                <div className="flex gap-1 flex-wrap">
                  <h2 className="text-blackPrimary-60 font-demi text-md">
                    {item?.title}
                  </h2>
                  {/* <span className="text-blackPrimary-100 font-demi text-md">
                    ურობერი 30 კაფსულა
                  </span> */}
                </div>
                <div className="ml-auto">
                  <VitaPercent icon={false} percent={"40"} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
});
